{
  "stepLabel": "Onboarding step",
  "actions": {
    "skip": "Skip",
    "letsGo": "Lets Go!"
  },
  "steps": {
    "buildYourTeam": {
      "title_czr": "Spin the Reels",
      "title_wh": "Spin & Lock",
      "body": "Use your 3 spins to reveal picks. Lock in the ones you like, spin again to change the rest."
    },
    "picksLockedGameOn": {
      "title": "Track Your Picks Live",
      "body": "Once submitted, follow your picks as games go live and see how they perform."
    },
    "winRealRewards": {
      "title": "Win Rewards",
      "body": "Get your picks right and win rewards, added straight to your account"
    }
  }
}
